function NotFound() {
	return (
		<div className="flex flex-col items-center justify-center h-screen">
			<h1 className="text-4xl font-bold">Not Found</h1>
			<p className="text-lg">The page you are looking for does not exist.</p>
			<a href="/" className="text-blue-500 hover:text-blue-600">Go back to the home page</a>
		</div>
	)
}

export default NotFound
